import React, { Fragment, useCallback, useEffect, useMemo, useRef, } from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { useTableContext } from "../../hooks/useTableContext";
import { useTableWidth } from "../../hooks/useTableWidth";
import { classNames } from "../../utils/classNames";
import { DATA_COL_INDEX_DRAWER } from "../../utils/gridColumns";
import { DrawerTable } from "./DrawerTable";
import { getDrawerData } from "./utilsV2Table";
import { TABLE_CELL_STYLING } from "./TableCell";
export function TableDrawer(props) {
    const ref = useRef(null);
    const { width, updateTableWidth } = useTableWidth(ref);
    const { setTableWidth } = useTableContext();
    useEffect(() => {
        if (setTableWidth)
            setTableWidth(width);
    }, [width]);
    const classes = useTableDrawerClasses();
    const { item, drawer, dropdown } = props;
    const drawerData = getDrawerData(item, drawer);
    const numberOfColumns = props?.headings.length;
    const colIndex = numberOfColumns + 1;
    const { dataId, dataTestId } = props;
    const rowKey = drawer?.rowKey;
    const isDrawerOpen = drawer?.openDrawers?.some(drawersAreOpen(item, rowKey));
    const [drawerOpen, setDrawerOpen] = React.useState(!!isDrawerOpen);
    const onDrawerChange = useCallback(() => {
        drawer?.onDrawerOpen && rowKey && drawer?.onDrawerOpen(item[rowKey]);
        updateTableWidth();
        setDrawerOpen(!drawerOpen);
    }, [drawer, drawerOpen, item, rowKey, updateTableWidth]);
    const label = useMemo(() => {
        if (drawer?.labelBuilder && rowKey) {
            return drawer.labelBuilder(item[rowKey], drawerOpen);
        }
        return drawer?.label ?? "Open";
    }, [drawer, drawerOpen, item, rowKey]);
    if (drawer?.showDrawer &&
        rowKey &&
        item[rowKey] &&
        !drawer.showDrawer(item[rowKey])) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ListCell, { role: "cell", ariaColIndex: colIndex, className: classNames(classes.drawerToggle), dataHook: "table-drawer" },
            React.createElement("div", { role: "button", className: `btn btn-link list__drawer--action list__drawer--action--${drawerOpen ? "open" : "closed"}`, "aria-expanded": drawerOpen, onClick: onDrawerChange, onKeyPress: onDrawerChange, "data-id": dataId && `${dataId}-drawer-${props?.rowIndex}`, "data-testid": dataTestId && `${dataTestId}-drawer-${props?.rowIndex}`, "data-hook": "table-drawer-action", style: { lineHeight: 1 } },
                React.createElement("span", { className: "list__drawer--action--title" }, label),
                React.createElement("span", { className: `glyphicon glyphicon-${drawerOpen ? "chevron-up" : "chevron-down"}` }))),
        drawerOpen && (React.createElement("div", { role: "cell", "aria-colindex": dropdown ? numberOfColumns + 3 : numberOfColumns + 2, "data-colindex": dropdown ? numberOfColumns + 2 : numberOfColumns + 1, className: classNames(classes.cellDrawer, classes.tableDrawer, classes.drawerPagination), ref: ref, "data-hook": "table-drawer-contents" },
            drawer?.headings && (React.createElement(DrawerTable, { headings: drawer?.headings, data: drawerData, rowKey: rowKey && item[rowKey], pagination: drawer?.pagination, dataId: dataId && `${dataId}-nestedTable-${props?.rowIndex}`, dataTestId: dataTestId && `${dataTestId}-nestedTable-${props?.rowIndex}` })),
            drawer?.component && rowKey && (React.createElement(TableDrawerComponent, { rowKey: rowKey, component: drawer.component, item: item }))))));
}
function drawersAreOpen(item, rowKey) {
    return (open) => rowKey && item[rowKey] === open;
}
export function TableDrawerComponent({ component, item, rowKey, }) {
    const formatter = (value) => {
        if (value !== null && value !== undefined && component) {
            return component(value);
        }
        return value;
    };
    return React.createElement(Fragment, null, formatter(item[rowKey]));
}
export function useTableDrawerClasses() {
    const useStyles = createUseStyles({
        tableDrawer: {
            marginTop: 4,
            "& .list__drawer--contents": {
                padding: 0,
                paddingTop: 0,
                paddingBottom: 0,
                "& > .list": {
                    margin: 0,
                },
            },
        },
        cellDrawer: {
            paddingRight: "0!important",
            gridArea: `${DATA_COL_INDEX_DRAWER}`,
            "& .list__drawer--action": {
                paddingLeft: "4px !important",
                paddingRight: "4px !important",
            },
        },
        drawerPagination: {
            "& .pagination": {
                margin: "8px 0 2px",
            },
        },
        drawerToggle: {
            ...TABLE_CELL_STYLING,
            gridArea: "data-drawer-toggle",
            textAlign: "right",
        },
    });
    return useStyles();
}
